import React, { useState } from 'react';
import Footer from './Footer';
import _ from 'lodash';
import {
  Wizard,
  WizardStep
} from '@patternfly/react-core';
import StepContainer from './StepContainer';
import { useTranslation } from 'localization/useTranslation';
import styles from './GlazeWizard.module.css';
import classNames from 'classnames';
import { useTabletOrMobile } from 'utils/hooks/useTabletOrMobile';

const BodyComponent = React.forwardRef((props, ref) => {
  const noClassName = _.omit(props, 'className');
  return <div ref={ref} className={classNames(props.className, styles.stepBody)} {...noClassName} />;
});

const body = {
  component: BodyComponent
};

const GlazeWizard = ({ onClose, steps, stepsContainerClassName, componentProps, isActionExecuting, onAction, onError, startIndex, actionButtonLabel }) => {
  const T = useTranslation();
  const isTabletOrMobile = useTabletOrMobile();

  const [isValid, setIsValid] = useState(_.fill(Array(steps.length), false));

  return (
    <Wizard height={(isTabletOrMobile) ? 800 : 750}
      footer={<Footer isNextDisabled />}
      onClose={onClose}
      isVisitRequired
      startIndex={startIndex}
    >
      { _.map(steps, (step, stepIndex) => {
        const Component = step.component;
        return (
          <WizardStep
            key={stepIndex}
            name={T.localize(step.name)}
            id={stepIndex}
            isHidden={step?.isHidden ?? false}
            isDisabled={step?.isDisabled ?? false}
            body={body}
            footer={<Footer
              isNextDisabled={!isValid[stepIndex]}
              onActionClick={onAction}
              isActionExecuting={isActionExecuting}
              actionButtonLabel={actionButtonLabel}
            />}
          >
            <StepContainer title={T.localize(step.name)} className={stepsContainerClassName}>
              <Component
                {...componentProps}

                onError={onError}
                setIsValid={validFlag => setIsValid(oldFlags => {
                  if (oldFlags[stepIndex] === validFlag) {
                    return oldFlags;
                  }
                  const newFlags = [...oldFlags];
                  newFlags[stepIndex] = validFlag;
                  return newFlags;
                })} />
            </StepContainer>
          </WizardStep>);
      }
      )
      }
    </Wizard>);
};

export default GlazeWizard;
